exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".invalid-feedback{display:block}.is-invalid .multiselect__tags,.is-invalid.ui.selection.dropdown{border-color:#dc3545}.dynamic-form-card{border-radius:1rem;box-shadow:0 6px 32px 0 rgba(60,60,120,.1),0 1.5px 6px 0 rgba(60,60,120,.1);background:#fff;margin:2rem auto;max-width:900px;padding:0;transition:box-shadow .3s}.dynamic-form-card:hover{box-shadow:0 12px 48px 0 rgba(60,60,120,.18),0 3px 12px 0 rgba(60,60,120,.12)}.b-card-body{padding:2.5rem 2rem 2rem}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-536de19a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/commonModal.vue
// module id = 1606
// module chunks = 0